import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { useRouteMatch } from 'react-router-dom';

import { formatClinicAddress } from 'pages/checkout/utils/addressUtils';
import { formatTimeSlot } from 'pages/checkout/utils/timeUtils';
import { selectRequestedAppointment } from 'pages/legacy-checkout/connect/selectors';
import { selectDataClinic } from 'pages/profile/connect/selectors';
import { getS3ImageUrl } from 'utils/s3Image';

import { AppointmentTime, ClinicAddress, ClinicAddressSkeleton, ClinicName, ClinicNameSkeleton, ClinicPhoto, ClinicPhotoSkeleton, Wrapper } from './AppointmentDetails-styled-components';

export const AppointmentDetails = () => {
  const clinic = useSelector(selectDataClinic);
  const { params } = useRouteMatch();
  const { clinicId: clinicIdString } = params as { clinicId: string };
  const clinicId = parseInt(clinicIdString, 10);
  const { slotId } = useSelector(selectRequestedAppointment);

  const { date: slotDate, time: slotTime } = useMemo(() => {
    const slot = clinic.slots?.find((slot: any) => slot.id === slotId);
    return slot || {};
  }, [clinic.slots, slotId]);

  // If results/:clinicId/ doesn't match what we've loaded to Redux, we're loading it
  const isLoadingClinicData = useMemo(() => {
    return clinic.id !== clinicId;
  }, [clinic.id, clinicId]);

  const formattedAddress = formatClinicAddress(clinic.address);
  const formattedTimeSlot = formatTimeSlot(slotDate, slotTime);

  const isInstantBook = Boolean(slotDate && slotTime);

  const clinicPhotoUrl = getS3ImageUrl(clinic.primaryPhoto);

  if (isLoadingClinicData) {
    return (
      <Wrapper>
        <ClinicPhotoSkeleton />
        <ClinicNameSkeleton />
        <ClinicAddressSkeleton />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <ClinicPhoto src={clinicPhotoUrl || ''} alt="" />
      <ClinicName>{clinic.name}</ClinicName>
      <ClinicAddress>{formattedAddress}</ClinicAddress>
      {isInstantBook && <AppointmentTime className="sensitive-data">{formattedTimeSlot}</AppointmentTime> }
    </Wrapper>
  );
};
